import { reactive } from 'vue'

// State is tiny and shared by the shell. GSAP / Flip are loaded before an
// actual portal transition, not before the first page can mount.
export const portal = reactive({
  open: false,
  lifted: false,
  to: '',
  label: '',
  height: 0,
})
export interface PortalFlight {
  mount(): void
  reveal(position: { top: number; left: number }): void
  cancel(): void
}
type Engine = typeof import('./page-portal-engine')
let engine: Engine | undefined
let loading: Promise<Engine> | undefined
export function preparePagePortal(): Promise<Engine> {
  if (engine) return Promise.resolve(engine)
  if (!loading) {
    loading = import('./page-portal-engine')
      .then((module) => {
        engine = module
        return module
      })
      .catch((error) => {
        loading = undefined
        throw error
      })
  }
  return loading
}
export function openPagePortal(...args: Parameters<Engine['openPagePortal']>) {
  if (!engine) throw new Error('Portal engine has not finished loading')
  return engine.openPagePortal(...args)
}
export function leavePortalPage(element: Element, done: () => void) {
  // No flight can exist until the engine has been loaded and opened it.
  if (engine) engine.leavePortalPage(element, done)
  else done()
}
